/* eslint-disable @typescript-eslint/no-this-alias */
import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import FrameworkAgreementsContent from './FrameworkAgreementsContent.jsx';

if (typeof window.FrameworkAgreementsRoot === 'undefined') {
    window.FrameworkAgreementsRoot = {};
} // endif

export const FrameworkAgreementsRoot = ({ sectionTag, windowId, context, societesId, membresId }) => {

    return (
        <FrameworkAgreementsContent
            context={context}
            societesId={societesId}
            membresId={membresId}
        />
    );

}

window.FrameworkAgreementsRoot = function (sectionTag = 'global') {

    const elements = document.querySelectorAll('[data-react="framework_agreements-index-content"]');

    elements.forEach(element => {
        const uniqueId = element.dataset.windowId || sectionTag;
        const context = sectionTag.split('-', 1)[0];
        const societesId = element.dataset.societesId || null;
        const membresId = element.dataset.membresId || null;

        if (window.FrameworkAgreementsRoot[uniqueId] && window.FrameworkAgreementsRoot[uniqueId].unmount) {
            window.FrameworkAgreementsRoot[uniqueId].unmount();
        }

        let attr = {
            sectionTag,
            windowId: uniqueId,
            context: context,
            societesId: societesId,
            membresId: membresId,
        };

        const root = createRoot(element);
        root.render(<FrameworkAgreementsRoot {...attr} />);

        window.FrameworkAgreementsRoot[uniqueId] = root;
    });

};
